import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Navigation = createReactComponent("Navigation", ["svg", defaultAttributes, [["polygon", {
  points: "3 11 22 2 13 21 11 13 3 11",
  key: "v6bc7e"
}]]]);
export default Navigation;